import React from "react";
import SideBar from '../Admin/SideBar'
import Header from "./Header";
import { FaUsers } from "react-icons/fa";
import { FaUserCheck } from "react-icons/fa";
import { FaLuggageCart } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { FaPrint } from "react-icons/fa";
import StatisticsChart from "./StatisticsChart";
import { exportServerDatabase } from "../../serverApi/server"

const Dashboard = () => {

  const getCurrentDateInEST = () => {
    const options = { timeZone: "America/New_York" };
    const estDate = new Date().toLocaleString("en-US", options);
    const date = new Date(estDate);
  
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
  
    return `${month}_${day}_${year}`;
  };

  const exportDatabase = async () => {
    const exportServerDatabaseResponse = await exportServerDatabase()
    console.log('\n exportServerDatabaseResponse:', exportServerDatabaseResponse)
    var currentDate= getCurrentDateInEST()
    const blob = new Blob([exportServerDatabaseResponse.data], { type: 'application/sql' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `stalbansprinting_production_${currentDate}.sql`;
    link.click();
  }

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl mb-1 sm:mb-3 font-medium text-blue-950">Dashboard</h1>
            <button
                className="bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 rounded text-white mr-4 md:mr-8"
                onClick={exportDatabase}
              >
                Export Database
            </button>
          </div>
          <p className="text-neutral-500 font-light">Stalbans printing Admin Dashboard</p>
          <div className="flex w-full gap-3 md:gap-5 lg:gap-10 justify-around items-center mt-3 sm:mt-7">
            <div className="w-full flex items-center gap-2 sm:gap-3 lg:gap-4 bg-white shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)]  p-3 md:p-4 rounded-xl">
              <div className="p-3 bg-blue-600 rounded-md">
                <FaUsers className="text-white min-[830px]:text-2xl lg:text-4xl"/>
              </div>
              <div>
                <p className="text-neutral-400 text-sm min-[830px]:text-base font-light">Visitors</p>
                <h3 className="text-base min-[830px]:text-xl">1,294</h3>
              </div>
            </div>
            <div className="w-full flex items-center gap-2 sm:gap-3 lg:gap-4 bg-white shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)] p-3 md:p-4 rounded-xl">
              <div className="p-3 bg-[#48ABF7] rounded-md">
                <FaUserCheck className="text-white min-[830px]:text-2xl lg:text-4xl"/>
              </div>
              <div>
                <p className="text-neutral-400 text-sm min-[830px]:text-base font-light">Subscribers</p>
                <h3 className="text-base min-[830px]:text-xl">1,303</h3>
              </div>
            </div>
            <div className="w-full flex items-center gap-2 sm:gap-3 lg:gap-4 bg-white shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)] p-3 md:p-4 rounded-xl">
              <div className="p-3 bg-[#31CE36] rounded-md">
                <FaLuggageCart className="text-white min-[830px]:text-2xl lg:text-4xl"/>
              </div>
              <div>
                <p className="text-neutral-400 text-sm min-[830px]:text-base font-light">Sales</p>
                <h3 className="text-base min-[830px]:text-xl">$ 1,345</h3>
              </div>
            </div>
            <div className="w-full flex items-center gap-2 sm:gap-3 lg:gap-4 bg-white shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)] p-3 md:p-4 rounded-xl">
              <div className="p-3 bg-[#6861CE] rounded-md">
                <FaCheckCircle className="text-white min-[830px]:text-2xl lg:text-4xl"/>
              </div>
              <div>
                <p className="text-neutral-400 text-sm min-[830px]:text-base font-light">Order</p>
                <h3 className="text-base min-[830px]:text-xl">578</h3>
              </div>
            </div>
          </div>

          <section className="mt-8">
            <div className="bg-white px-5 pt-1 pb-2 shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)] rounded-xl">
              <div className="flex items-center justify-between border-b py-4">
                <h2 className="text-2xl text-[#2A2F5B]">User Statistics</h2>
                <div className="flex items-center gap-3">
                  <button className="text-[#31CE36] text-sm px-4 py-2 rounded-full bg-green-50 hover:text-white hover:bg-[#31CE36] duration-200">Export</button>
                  <button className="text-[#48ABF7] text-sm px-4 py-2 rounded-full bg-blue-50 hover:text-white hover:bg-[#48ABF7] duration-200 flex items-center gap-1"><FaPrint />Print</button>
                </div>
              </div>
              <StatisticsChart />
            </div>
          </section>

        </div>

      </div>  
    </div>
  );
};

export default Dashboard;